// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__GnKFn","infoBtn":"quickbooks_infoBtn__D2_Yi","formBox":"quickbooks_formBox__14kz4","formFooter":"quickbooks_formFooter__ILHbU"};